import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators, FormsModule } from '@angular/forms';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialog as MatDialog,
  MatLegacyDialogModule as MatDialogModule
} from '@angular/material/legacy-dialog';
import { LocalStorageService } from '../../connectors/localstorage';
import { RequesSetupService } from '../../services/request-setup.service';
import { ViewDetailsLoaderComponent } from '../view-details-loader/view-details-loader.component';
import { Subject } from 'rxjs';
import { ModalSuccessComponent } from '../modal-success/modal-success.component';
import Swal from 'sweetalert2';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { NgFor, NgClass, NgIf } from '@angular/common';
import { MatGridListModule } from '@angular/material/grid-list';

@Component({
  selector: 'app-modal-create-setup',
  templateUrl: './modal-create-setup.component.html',
  styleUrls: ['./modal-create-setup.component.css'],
  standalone: true,
  imports: [
    MatGridListModule,
    NgFor,
    MatFormFieldModule,
    NgClass,
    MatInputModule,
    FormsModule,
    NgIf,
    MatSlideToggleModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule
  ]
})
export class ModalCreateSetupComponent implements OnInit {
  email = new FormControl('', [Validators.required, Validators.email]);
  creationDate: any;
  createdBy: any;
  roleAcess: any;
  action: any;
  editMode: boolean = false;
  modalClose = new Subject<boolean>();
  userNameValue: string = '';
  shortName: string = '';
  shortNameError: string = '';

  constructor(
    public dialogRef: MatDialogRef<any>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private serviceLocalStorage: LocalStorageService,
    private requestService: RequesSetupService
  ) {
    this.modalClose = new Subject<boolean>();
  }

  async ngOnInit(): Promise<void> {
    this.getRoleAcess();
  }

  getRoleAcess() {
    this.roleAcess = this.serviceLocalStorage.decryptAndGet('roles-access');
  }

  closeDialog() {
    this.dialogRef.close();
  }

  getErrorMessage() {
    if (this.email.hasError('required')) {
      return 'You must enter a value';
    }

    return this.email.hasError('email') ? 'Not a valid email' : '';
  }

  edit(edit: any) {
    if (edit.title.toLowerCase() !== 'save') {
    } else if (edit.title.toLowerCase() === 'cancel') {
      this.closeDialog();
    }
  }

  compareAcess(req: any): boolean {
    if (req[0].toLowerCase() === 'none') {
      return false;
    }

    if (req[0].toLowerCase() !== this.roleAcess[0].toLowerCase()) {
      return true;
    }

    return false;
  }

  updateDisabled(obj: any, state: boolean) {
    if (typeof obj === 'object' && obj !== null) {
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          if (key === 'disabled' && obj['type'] !== 'flag') {
            obj[key] = state;
          } else {
            this.updateDisabled(obj[key], state);
          }
        }
      }
    }
  }

  actionEdit(action: any) {
    if (action.title.toLowerCase() === 'cancel') {
      this.data.modal.fields.forEach((field: any) => {
        field.value = [''];
      });
      this.closeDialog();
    } else if (
      action.type.toLowerCase() === 'save-team' ||
      action.type.toLowerCase() === 'save-role' ||
      action.type.toLowerCase() === 'create-team' ||
      action.type.toLowerCase() === 'create-role' ||
      action.type.toLowerCase() === 'create-priority' ||
      action.type.toLowerCase() === 'create-user' ||
      action.type.toLowerCase() === 'save-request'
    ) {
      const fieldToBodyMap = this.getFieldToBodyMap(action.type.toLowerCase());
      this.save(action.endpoint.saveData.path, action.endpoint.saveData.body, fieldToBodyMap, action);
    }
  }

  updateShortName(fullName: string): void {
    if (fullName) {
      let trimmedUsername = fullName.trim().replace(/ +(?= )/g, '');
      const names = trimmedUsername.split(' ');

      let firstName = '';
      let secondName = '';

      if (names.length > 0) {
        firstName = names[0];
      }

      if (names.length > 1) {
        secondName = names[1];
      }

      this.data.modal.fields.forEach((field: any) => {
        let shortName: string = '';
        if (field.title === 'Short Name') {
          shortName = field.value = this.shortName = `${firstName.charAt(0)}${secondName.charAt(0)}`.toUpperCase();

          if (this.shortName.length !== 2) {
            this.shortNameError = 'This field is mandatory and requires 2 characters';
            return;
          }
          field.value = this.shortName = shortName;
          this.shortNameError = '';
        }
      });
    } else {
      this.shortName = '';
    }
  }

  getFieldToBodyMap(type: string): { [fieldKey: string]: string } {
    switch (type) {
      case 'save-team':
      case 'create-team':
        return { teamName: 'Team Name' };
      case 'save-role':
      case 'create-role':
        return { roleName: 'Role Name' };
      case 'create-user':
        return { userName: 'User Name', emailAddress: 'Email Address', shortName: 'Short Name' };
      case 'create-priority':
        return { priorityName: 'Priority Name' };
      case 'save-request':
        return {
          estimatedDeadline: 'Estimated Deadline',
          priorityId: 'Priorities',
          requestName: 'Request Name',
          shortName: 'Short Name',
          teamId: 'Team Id',
          teamName: 'Team Name'
        };
      default:
        return {};
    }
  }

  async save(path: any, body: any, fieldToBodyMap: { [fieldKey: string]: string }, actionType?: any) {
    const shortNameField = this.data.modal.fields.find((field: any) => field.title === 'Short Name');

    this.data.modal.fields.forEach((field: any) => {
      if (field.title === 'User Name' && field.value) {
        field.value = field.value.replace(/ +(?= )/g, '').trim();
      }
    });

    if (shortNameField && shortNameField.value?.length !== 2) {
      this.shortNameError = 'This field is mandatory and requires 2 characters';
      return;
    }

    if (this.data.modal.fields.some((field: any) => !field.value)) {
      return;
    }
    await this.openProgressDialog('Creating. Please wait');

    for (const fieldKey in fieldToBodyMap) {
      if (fieldToBodyMap.hasOwnProperty(fieldKey)) {
        const field = this.data.modal.fields.find((field: any) => field.title === fieldToBodyMap[fieldKey]);
        if (field) {
          body[fieldKey] = field.value.trim();
        }
      }
    }

    if (actionType.type.toLowerCase() === 'create-user') {
      if (this.checkUserExists(body)) {
        this.errorUser();
        this.fecharModal();
        return;
      } else {
        body.createdBy = this.data.modal.idUser;
        this.actionSetup(path, body);
      }
    } else if (actionType.type.toLowerCase() === 'save-request') {
      body.createdBy = this.data.modal.idUser;
      body.estimatedDeadline = this.data.modal.fields[2].value;
      body.priorityId = this.data.modal.select[1].selectedOption;
      body.requestName = this.data.modal.fields[0].value;
      body.shortName = this.data.modal.fields[1].value;
      (body.teamId = this.data.modal.select[0].selectedOption),
        (body.requestOwnerId = this.data.modal.select[2].selectedOption);
      this.actionSetup(path, body);
    } else {
      body.createdBy = this.data.modal.idUser;
      this.actionSetup(path, body);
    }
  }

  checkUserExists(body: any): boolean {
    const userExists = this.data.users.some((user: any) => {
      return user.toString().toLowerCase() === body?.emailAddress.toString().toLowerCase();
    });

    return userExists;
  }

  actionSetup(path: any, body: any) {
    this.requestService.actionSetup(path, body).subscribe((resp: any) => {
      this.data?.users?.push(resp.emailAddress);
      this.data.modal.fields.forEach((field: any) => {
        field.value = [''];
      });

      this.fecharModal();
      this.sweetAlert();
    });
  }

  openProgressDialog(text: any): Promise<void> {
    return new Promise((resolve) => {
      const dialogRef = this.dialog.open(ViewDetailsLoaderComponent, {
        autoFocus: false,
        closeOnNavigation: true,
        disableClose: true,
        height: '250px',
        width: '600px',
        panelClass: 'center-modal',
        data: { modalClose$: this.modalClose, text: text }
      });

      dialogRef.afterOpened().subscribe(() => {
        setTimeout(() => {
          resolve();
        }, 500);
      });
    });
  }

  openSuccessModal() {
    const dialogRef = this.dialog.open(ModalSuccessComponent, {
      autoFocus: false,
      closeOnNavigation: true,
      disableClose: true,
      height: '250px',
      width: '700px',
      panelClass: 'center-modal'
    });

    dialogRef.afterOpened().subscribe(() => {});
  }

  getFieldColspan(index: number): number {
    const numFields = this.data.modal.fields.length;

    if (numFields === 1) {
      return 2;
    } else {
      return index === numFields - 1 ? 2 : 1;
    }
  }

  fecharModal() {
    this.modalClose.next(true);
  }

  sweetAlert() {
    Swal.fire({
      title: 'Success!',
      text: 'Your informations has been saved.',
      icon: 'success',
      showConfirmButton: true,
      confirmButtonText: 'OK',
      confirmButtonColor: '#3085D6'
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: 'You can continue adding status to this list',
          text: 'Would you like to do it now?',
          icon: 'info',
          showCancelButton: true,
          showConfirmButton: true,
          cancelButtonColor: '#DC3741',
          confirmButtonColor: '#3085D6',
          cancelButtonText: 'NO, thanks!',
          confirmButtonText: 'Yes, continue!',
          reverseButtons: true
        }).then((result) => {
          if (result.isConfirmed) {
            this.reset('reabrir');
          } else if (result.isDismissed) {
            this.closeDialog();
          }
        });
      }
    });
  }

  // errorUser() {
  //   Swal.fire({
  //     title: 'User Already Exists',
  //     text: 'This user already exists. Please choose a different email address.',
  //     icon: 'error',
  //     showConfirmButton: true,
  //     confirmButtonText: 'OK',
  //     confirmButtonColor: '#3085D6',
  //   }).then(() => {
  //   });
  // }

  errorUser() {
    Swal.fire({
      title: 'Error',
      text: 'This user already exists. \nPlease choose a different email address.',
      icon: 'error',
      showConfirmButton: true,
      confirmButtonText: 'OK',
      confirmButtonColor: '#3085D6',
      customClass: 'custom-swal-error',
      footer:
        '<i class="icon-support"></i><a href="mailto:AM.US.OM.BusinessSolutions@global.ntt">click here to contact the support</a>'
    }).then(() => {});
  }

  reset(result: any) {
    this.dialogRef.close(result);
  }
}
